import getAwsCredentials from "./AwsCredentialsFromToken";
import { SignatureV4 } from "@aws-sdk/signature-v4";
import { Sha256 } from "@aws-crypto/sha256-js";
import { AppSettings } from "../config/AppSettings";

const service = "execute-api";
const contentType = "application/json";

export const concatenateUrl = (path: string, base: string, urlParams?: any) => {
  const url = new URL(path, base);
  if (urlParams) {
    const urlSearchParams = new URLSearchParams(urlParams);
    url.search = urlSearchParams.toString();
  }
  return url;
};

export const callApiGw = async (path: string, method: string, options?: { body?: any; urlParams?: any }) => {
  // Initialize application settings
  const baseUrl = concatenateUrl(path, AppSettings().apiUrl, options?.urlParams);
  const signedRequest = await getSignedRequest(method, baseUrl, options?.body);
  return fetch(baseUrl.toString(), signedRequest);
};

const getSignedRequest = async (method: string, apiUrl: URL, body?: any) => {
  const credentials = await getAwsCredentials();
  const sigv4 = new SignatureV4({
    service,
    region: AppSettings().region,
    credentials: {
      accessKeyId: credentials.accessKeyId,
      secretAccessKey: credentials.secretAccessKey,
      sessionToken: credentials.sessionToken,
    },
    sha256: Sha256,
  });
  const signedRequest = await sigv4.sign({
    method: method,
    hostname: apiUrl.host,
    path: apiUrl.pathname,
    protocol: apiUrl.protocol,
    headers: {
      "Content-Type": contentType,
      host: apiUrl.hostname, // compulsory
    },
    body: body ? JSON.stringify(body) : undefined,
    query: apiUrl.searchParams.size ? Object.fromEntries(apiUrl.searchParams) : undefined,
  });
  // delete for security
  delete signedRequest["headers"]["host"];
  return signedRequest;
};
